import React from "react";
import { Link } from "react-router-dom";

const CtaSection = ({ t, lang }) => {
    return (
        <section
            className="py-5 position-relative overflow-hidden"
            style={{
                background: "linear-gradient(135deg, var(--primary) 0%, #85763d 100%)",
            }}
        >
            {/* Decorative Background */}
            <div
                className="position-absolute top-0 start-0 w-100 h-100"
                style={{ opacity: 0.1 }}
            >
                <div
                    className="position-absolute rounded-circle bg-light"
                    style={{
                        width: 400,
                        height: 400,
                        top: -200,
                        right: -100,
                    }}
                ></div>
                <div
                    className="position-absolute rounded-circle bg-light"
                    style={{
                        width: 300,
                        height: 300,
                        bottom: -150,
                        left: -100,
                    }}
                ></div>
            </div>

            <div className="container position-relative py-5">
                <div className="row align-items-center justify-content-center">
                    <div
                        className="col-lg-10 col-xl-8 text-center"
                        data-aos="zoom-in"
                    >
                        {/* Icon */}
                        <div className="mb-4">
                            <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-dark bg-opacity-10 p-4">
                                <i
                                    className="ri-rocket-2-line text-dark"
                                    style={{ fontSize: "60px" }}
                                ></i>
                            </div>
                        </div>

                        {/* Title */}
                        <h2 className="fw-bold display-4 text-dark mb-4">
                            {t("home_cta_title")}
                        </h2>

                        {/* Description */}
                        <p
                            className="lead text-dark mb-5 mx-auto"
                            style={{ maxWidth: 600, opacity: 0.9 }}
                        >
                            {t("home_cta_desc")}
                        </p>

                        {/* CTA Buttons */}
                        <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center align-items-center">
                            <Link
                                to="/contact"
                                className="btn btn-dark btn-lg px-5 py-3 fw-bold shadow-lg"
                            >
                                {t("home_cta_btn")}
                                <i className="ri-arrow-right-line ms-2"></i>
                            </Link>

                            <Link
                                to="/services"
                                className="btn btn-outline-dark btn-lg px-5 py-3 fw-bold"
                            >
                                {t("home_why_1") /* Explore Services translation */}
                            </Link>
                        </div>

                        {/* Trust Indicators */}
                        <div className="row g-4 mt-5 pt-4">
                            <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <i className="ri-shield-check-line text-dark fs-3"></i>
                                    <div className="text-start">
                                        <div className="fw-bold text-dark">
                                            {t("Trusted Partner") || "Trusted Partner"}
                                        </div>
                                        <small className="text-dark opacity-75">
                                            {t("200+ Projects") || "200+ Projects"}
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <i className="ri-time-line text-dark fs-3"></i>
                                    <div className="text-start">
                                        <div className="fw-bold text-dark">
                                            {t("Quick Response") || "Quick Response"}
                                        </div>
                                        <small className="text-dark opacity-75">
                                            {t("24/7 Support") || "24/7 Support"}
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4" data-aos="fade-up" data-aos-delay="300">
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <i className="ri-star-line text-dark fs-3"></i>
                                    <div className="text-start">
                                        <div className="fw-bold text-dark">
                                            {t("Top Quality") || "Top Quality"}
                                        </div>
                                        <small className="text-dark opacity-75">
                                            {t("10+ Years") || "10+ Years"}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CtaSection;
